import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle'
import { TranslatePipe } from '@ngx-translate/core'

export type ButtonToggleOption = {
  id: string | null
  labelTranslationKey: string
}

@Component({
  selector: 'app-button-toggle',
  imports: [FormsModule, MatButtonToggleGroup, MatButtonToggle, TranslatePipe],
  templateUrl: './button-toggle.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './button-toggle.component.scss',
})
export class ButtonToggleComponent {
  @Input({ required: true })
  options!: ButtonToggleOption[]

  @Input({ required: true })
  value!: string | null

  @Output()
  update = new EventEmitter<string>()

  chooseOption(id: string) {
    this.update.emit(id)
  }
}
